import 'regenerator-runtime/runtime'
import '../scss/index.scss'
import $ from 'jquery'
import Turbolinks from 'turbolinks'
import LazyLoad from 'vanilla-lazyload'
import shuffle from './shuffle'

$.fn.shuffle = shuffle

Turbolinks.start()

const COLUMN_COUNT = 12

const lazy = new LazyLoad()

$(() => {
  $(document).on('click', 'a[href="#"]', function(event) {
    event.preventDefault()
  })

  splash()
  createGrid()
  clicker()
})

$(window).on('load', () => {
  setupProjects()
  setupPrecedes()
})

$(document).on('turbolinks:load', () => {
  setupProjects()
})

function createGrid() {
  let show = sessionStorage.getItem('showgrid') === 'true'

  $(document).on('keydown', function(event) {
    if(event.key === 'g' && event.ctrlKey) {
      event.preventDefault()
      show = !show
      $('.grid').css('display', show ? 'grid' : 'none')
      sessionStorage.setItem('showgrid', show)
    }
  })

  if(show) $('.grid').css('display', 'grid')
}

async function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

async function setupProjects() {
  await document.fonts.ready

  const getCSSVar = name => parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name))

  const rootEm = getCSSVar('font-size')

  const outer = getCSSVar('--outer') 
  const margin = getCSSVar('--margin')

  const outerPx = outer * rootEm
  const marginPx = margin * rootEm

  const col = (window.innerWidth - (outerPx*2) + marginPx) / COLUMN_COUNT
  const mincol = 3
  const maxcol = 6

  $('.projects:not(.processed)').each(function() {
    $(this).addClass('processed')

    $(this).find('.project.unlisted').shuffle()

    $(this).find('.project').each(function() {
      const $project = $(this)
      const width = $(this).outerWidth() - marginPx + 10
      const ccount = Math.max(Math.min(maxcol, Math.ceil(width / col)), mincol)
      const cwidth = (ccount / COLUMN_COUNT)*100+'%'
      $(this).data('col', ccount)
      $(this).css('width', `calc(100% * ${ccount} / ${COLUMN_COUNT})`)
      $(this).attr('data-col', ccount)
      $(this).find('.project__meta .comma-list').show()
      $(this).on('click', '.expand-trigger', function(event) {
        event.preventDefault()
        if(!$project.hasClass('expanded')) {
          $project.addClass('expanded').siblings().removeClass('expanded')
          $project.get(0).scrollIntoView({behavior: 'smooth'})
        }
      })
      $(this).on('click', '.project__close', function(event) {
        event.preventDefault()
        event.stopPropagation()
        $project.removeClass('expanded')
        $project.find('video').each(function() {
          const video = this
          video.pause()
          video.currentTime = 0
        })
      })
    })

    let lastTop
    let rows = []
    let row = []

    $(this).find('.project, .project-bar').each(function() {
      const offset = $(this).offset()
      if(offset) {
        if(lastTop !== undefined && offset.top - lastTop > 50) {
          if(row.length) rows.push(row)
          row = [this]
        } else {
          row.push(this)
        }

        lastTop = offset.top
      }
    })

    if(row.length) rows.push(row)

    const createBreak = () => $('<div class="project-break" />')

    rows.forEach(row => {
      const first = row[0]
      const last = row[row.length-1]

      createBreak().insertAfter(last)

      const rowProjects = row.filter(p => $(p).hasClass('project'))

      if($(first).hasClass('project-bar')) $(first).remove()
      if($(last).hasClass('project-bar') && rowProjects.length > 1) $(last).remove()
    })

    $(this).css('visibility', 'visible')
  })

  setTimeout(() => lazy.update(), 125)
}

function splash() {
  $(document).on('click', '.splash', function(event) {
    event.preventDefault()
    $('body').removeClass('show-splash').removeClass('prevent-scroll')
  })
  $(document).on('click', '.splash a', function(event) {
    event.stopPropagation()
  })
}

Turbolinks.scroll = {}
Turbolinks.refer = null

$(document).on('click', '[data-turbolinks-scroll=false]', function(event) {
  Turbolinks.scroll['top'] = window.scrollY
})

$(document).on('turbolinks:render', function() {
  if(Turbolinks.scroll['top']) {
    window.scrollTo({top: Turbolinks.scroll['top']})
  }
  Turbolinks.scroll = {}
})

$(document).on('click', '[data-turbolinks-refer]', function(event) {
  Turbolinks.refer = $(this).attr('data-turbolinks-refer')
})

$(document).on('turbolinks:request-start', function(event) {
  let xhr = event.originalEvent.data.xhr
  xhr.setRequestHeader('X-Turbolinks-Refer', Turbolinks.refer)
  Turbolinks.refer = null
})

function setupPrecedes() {
  $(document).on('click', '.project .ellipsis', function(event) {
    event.preventDefault()
    $(this).closest('.project__content').addClass('open')
  })
}

function clicker() {
  function activate($slide) {
    $slide.find('video').each(function() {
      const video = this
      video.currentTime = 0 
      video.play()
    })
  }

  function deactivate($slides) {
    $slides.each(function() {
      $(this).find('video').each(function() {
        const video = this
        video.pause()
        video.currentTime = 0 
      })
    })
  }

  $(document).on('click', '.clicker__nav[data-dir="next"]', function(event) {
    const $slides = $(this).parent().find('.clicker__slides').children()
    const $current = $slides.first()
    $(this).parent().find('.clicker__slides').append($current)

    const $next = $(this).parent().find('.clicker__slides').children().first()

    activate($next)
    deactivate($slides.not($next))
  })

  $(document).on('click', '.clicker__nav[data-dir="prev"]', function(event) {
    const $slides = $(this).parent().find('.clicker__slides').children()
    const $next = $slides.last()
    $(this).parent().find('.clicker__slides').prepend($next)

    activate($next)
    deactivate($slides.not($next))
  })
}